export const cutStringHandler = (string?: string): string => {
  if (string) {
    const charsLimit = 177;

    return string.length > charsLimit ? string.slice(0, charsLimit) + '...' : string;
  }

  return "";
};